export const filledVariants = [
  {
    design: 'filled',
    intent: 'success',
    class: ['bg-success text-on-success'],
  },
  {
    design: 'filled',
    intent: 'alert',
    class: ['bg-alert text-on-alert'],
  },
  {
    design: 'filled',
    intent: 'error',
    class: ['bg-error text-on-error'],
  },
  {
    design: 'filled',
    intent: 'info',
    class: ['bg-info text-on-info'],
  },
  {
    design: 'filled',
    intent: 'neutral',
    class: ['bg-neutral text-on-neutral'],
  },
  {
    design: 'filled',
    intent: 'main',
    class: ['bg-main text-on-main'],
  },
  {
    design: 'filled',
    intent: 'basic',
    class: ['bg-basic text-on-basic'],
  },
  {
    design: 'filled',
    intent: 'support',
    class: ['bg-support text-on-support'],
  },
  {
    design: 'filled',
    intent: 'accent',
    class: ['bg-accent text-on-accent'],
  },
  {
    design: 'filled',
    intent: 'inverse',
    class: ['bg-surface-inverse text-on-surface-inverse'],
  },
] as const

export const tintedVariants = [
  {
    design: 'tinted',
    intent: 'success',
    class: ['bg-success-container text-on-success-container'],
  },
  {
    design: 'tinted',
    intent: 'alert',
    class: ['bg-alert-container text-on-alert-container'],
  },
  {
    design: 'tinted',
    intent: 'error',
    class: ['bg-error-container text-on-error-container'],
  },
  {
    design: 'tinted',
    intent: 'info',
    class: ['bg-info-container text-on-info-container'],
  },
  {
    design: 'tinted',
    intent: 'neutral',
    class: ['bg-neutral-container text-on-neutral-container'],
  },
  {
    design: 'tinted',
    intent: 'main',
    class: ['bg-main-container text-on-main-container'],
  },
  {
    design: 'tinted',
    intent: 'basic',
    class: ['bg-basic-container text-on-basic-container'],
  },
  {
    design: 'tinted',
    intent: 'support',
    class: ['bg-support-container text-on-support-container'],
  },
  {
    design: 'tinted',
    intent: 'accent',
    class: ['bg-accent-container text-on-accent-container'],
  },
  {
    design: 'tinted',
    intent: 'inverse',
    class: ['bg-surface-inverse text-on-surface-inverse'],
  },
] as const
